import React from 'react';
import {
  FaTimesCircle,
  FaExclamationTriangle,
  FaInfoCircle,
} from 'react-icons/fa';

const StatusBadge = ({ status, label, note }) => {
  const normalizedStatus = (status || '').toUpperCase();

  const getStatusConfig = () => {
    switch (normalizedStatus) {
      case 'ON_TIME':
      case 'ON TIME':
      case 'HEALTHY':
      case 'GROUP HEALTHY':
        return {
          badgeClass: 'status-pill pill-on-time',
          icon: null,
          displayText: label || 'ON TIME',
        };
      case 'CANCELLED':
      case 'CANCELED':
        return {
          badgeClass: 'status-pill pill-cancelled',
          icon: <FaTimesCircle className="badge-icon" />,
          displayText: label || 'CANCELLED',
        };
      case 'IROP':
      case 'IRROP':
      case 'WARNING':
      case 'DELAYED':
      case 'CATERING DELAYED':
        return {
          badgeClass: 'status-pill pill-irop',
          icon: <FaExclamationTriangle className="badge-icon" />,
          displayText: label || 'IROP',
        };
      case 'CRITICAL':
      case 'MISSING MEALS':
      case 'MISSING_MEALS':
        return {
          badgeClass: 'status-pill pill-critical',
          icon: <FaTimesCircle className="badge-icon" />,
          displayText: label || 'MISSING MEALS',
        };
      default:
        return {
          badgeClass: 'status-pill pill-default',
          icon: <FaInfoCircle className="badge-icon" />,
          displayText: label || normalizedStatus,
        };
    }
  };

  const { badgeClass, icon, displayText } = getStatusConfig();

  return (
    <div className="status-cell-container">
      <span className={badgeClass}>
        {icon}
        <span className="pill-text">{displayText}</span>
      </span>
      {/* {note && <span className="status-disruption-note">{note}</span>} */}
    </div>
  );
};

export default StatusBadge;
